/**
 * Real numbers for the landing page. Every figure here came out of the
 * simulation in sim/ against 2024–25 nflverse box scores — nothing invented.
 */

/** A greedy manager's actual burn board through Week 10 of 2025. */
export const BURNED: Record<string, Record<string, number>> = {
  ARI: { QB: 1, TE: 5 }, BAL: { RB: 1, QB: 3, WR: 3 }, KC: { WR: 1, DEF: 1, QB: 5 },
  BUF: { TE: 1, QB: 2, RB: 10 }, CLE: { K: 1 }, SF: { RB: 2, TE: 2, K: 8 },
  LAC: { WR: 2, QB: 9 }, IND: { K: 2, RB: 6 }, DEN: { DEF: 2, QB: 8 },
  ATL: { RB: 3, DEF: 3 }, GB: { TE: 3, RB: 7 }, DAL: { K: 3, QB: 6, WR: 6, TE: 6 },
  CHI: { QB: 4, WR: 4, K: 7, RB: 8 }, DET: { RB: 4, DEF: 6 }, NE: { TE: 4, WR: 10 },
  TEN: { K: 4 }, SEA: { DEF: 4, K: 5, WR: 7 }, JAX: { RB: 5, DEF: 5 },
  LAR: { WR: 5, DEF: 9 }, TB: { K: 6, DEF: 10 }, PHI: { QB: 7, TE: 7 },
  PIT: { DEF: 7, TE: 8, K: 9 }, MIN: { WR: 8 }, HOU: { DEF: 8, K: 10 },
  CAR: { RB: 9 }, CIN: { WR: 9 }, NYG: { TE: 9, QB: 10 }, LV: { TE: 10 },
}

export const TEAMS = [
  'ARI','ATL','BAL','BUF','CAR','CHI','CIN','CLE','DAL','DEN','DET','GB',
  'HOU','IND','JAX','KC','LAC','LAR','LV','MIA','MIN','NE','NO','NYG','NYJ',
  'PHI','PIT','SEA','SF','TB','TEN','WAS',
]

export const POSITIONS = ['QB', 'RB', 'WR', 'TE', 'K', 'DEF'] as const

/** A real Week 3 lineup and what it actually scored. */
export const LINEUP = [
  { slot: 'QB',   unit: 'BAL QB',  vs: 'vs CLE', pts: 27.0 },
  { slot: 'RB',   unit: 'ATL RB',  vs: '@ CAR',  pts: 17.1 },
  { slot: 'WR',   unit: 'BAL WR',  vs: 'vs CLE', pts: 22.8 },
  { slot: 'TE',   unit: 'GB TE',   vs: '@ TEN',  pts: 12.6 },
  { slot: 'K',    unit: 'DAL K',   vs: 'vs NYG', pts: 8.0 },
  { slot: 'D/ST', unit: 'ATL DEF', vs: '@ CAR',  pts: 2.0 },
]

/** Top unit scores from Week 3, 2025 — the scoring ticker. */
export const TICKER: [string, number][] = [
  ['DET RB', 53.3], ['LV WR', 50.1], ['CHI WR', 47.9], ['SEA WR', 40.6],
  ['PHI WR', 38.4], ['WAS WR', 35.7], ['NYJ WR', 33.1], ['LAR WR', 32.8],
  ['TB WR', 32.8], ['LAC WR', 32.2], ['IND RB', 32.2], ['DAL WR', 32.1],
  ['MIN RB', 31.0], ['MIA WR', 30.5], ['KC WR', 30.4], ['IND WR', 29.4],
  ['CHI QB', 29.1], ['PHI QB', 29.0], ['NE TE', 28.8], ['SF RB', 27.8],
  ['HOU WR', 27.4], ['BAL TE', 27.3], ['WAS RB', 27.3], ['BAL QB', 27.0],
  ['NYG RB', 26.8], ['LV QB', 26.1], ['BUF WR', 25.5], ['LAC RB', 24.7],
]

/** The injured-starter proof. */
export const INJURY_PROOF = [
  { who: 'Starter — out at halftime', yds: 150, td: 1, int: 1, pts: 8.0 },
  { who: 'Backup — finished the game', yds: 175, td: 2, int: 0, pts: 17.0 },
]

/** Validation figures, all from the season simulation. */
export const STATS = [
  { value: 6526,  suffix: '',    label: 'unit-weeks of real box scores replayed',
    sub: '2024 + 2025, burn rule enforced' },
  { value: 12.1,  suffix: ' pts', label: 'average weekly winning margin',
    sub: 'on an 86.5-point score · 1 tie in 36 weeks' },
  { value: 108,   suffix: ' of 192', label: 'units a manager spends in a season',
    sub: '18 of the 32 rooms at every position' },
]
